export default "__VITE_ASSET__vC5ZvyPN__"